import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './NavBar.css';

function NavBar() {
  const { currentUser } = useAuth();
  const location = useLocation();

  // Simplified navbar structure
  return (
    <nav className="simplified-navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/" className="navbar-logo-text">
            NSTP Management System
          </Link>
        </div>
        
        <div className="navbar-auth">
          {!currentUser ? (
            <>
              <Link to="/login" className="auth-button login-button">
                <i className="bi bi-box-arrow-in-right"></i> LOGIN
              </Link>
              <Link to="/register" className="auth-button register-button">
                <i className="bi bi-person-plus"></i> REGISTER
              </Link>
            </>
          ) : (
            <div className="user-info">
              <div className="user-avatar">
                {currentUser.email.charAt(0).toUpperCase()}
              </div>
              {location.pathname !== '/dashboard' && !location.pathname.includes('/admin') ? (
                <Link to="/dashboard" className="auth-button">Dashboard</Link>
              ) : (
                <Link to="/" className="auth-button login-button">
                  <i className="bi bi-house"></i> Home
                </Link>
              )}
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

export default NavBar; 